import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, AppBar, Box, Toolbar, IconButton, Typography, useScrollTrigger, Avatar, Slide, SwipeableDrawer, BottomNavigation, BottomNavigationAction, ListItemText, ListItemIcon, List, ListItem, ListItemButton, Divider, Collapse, useTheme, Stack } from "@mui/material";
import { MenuRounded, LightModeRounded, DarkModeRounded, SettingsRounded, ExpandLessOutlined, ExpandMoreOutlined, ArrowUpwardRounded, ArrowForwardRounded, ArrowDownwardRounded, ArrowBackRounded, CloseRounded, LinkedIn, Telegram } from "@mui/icons-material";

import { HeaderPages } from "./HeaderPages";

import { ColorModeContext } from "./App";

import gustavocxLight from "../assets/img/ico.png";

const HideOnScroll = (props) => {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

/* const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("xs")]: {
      width: "5ch",
      "&:focus": {
        width: "7ch",
      },
    },

    [theme.breakpoints.up("sm")]: {
      width: "7ch",
      "&:focus": {
        width: "10ch",
      },
    },

    [theme.breakpoints.up("md")]: {
      width: "10ch",
      "&:focus": {
        width: "15ch",
      },
    },
  },
})); */

export default function Header(props) {
  /* Theme */
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);

  /* Menu */
  const [state, setState] = React.useState({
    top: true,
    left: true,
    bottom: true,
    right: false,
  });

  const [value, setValue] = React.useState(0);

  const [drawerAnchor, setDrawerAnchor] = React.useState("right");

  const [open, setOpen] = React.useState(false);
  const [openSettingMenu, setOpenSettingMenu] = React.useState(false);
  const handleOpenMenu = () => {
    setOpen(!open);
  };

  const toggleDrawer = (drawerAnchor, open) => (event) => {
    if (event && event.type === "keydown" && event.key === "Esq") {
      handleOpenMenu();
      setState({
        ...state,
        [drawerAnchor]: open,
      });
      setOpenSettingMenu(false);
    }
    setState({
      ...state,
      [drawerAnchor]: open,
    });
    handleOpenMenu();
    setOpenSettingMenu(false);
  };

  /* Setting Menu */
  const [selectedIndexListMenu, setSelectedIndexListMenu] = React.useState(1);

  /* Navigation */
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const pages = HeaderPages();

  /* Router */
  const location = useLocation();
  const navigate = useNavigate();
  const handleNavigate = (event, index, item) => {
    let RuteString = item.toLowerCase();
    navigate(`/${RuteString}`);
    setSelectedIndex(index);
    setValue(index);
    window.scrollTo(0, 0);
  };

  React.useEffect(() => {
    var indexLocation =
      location.pathname === "/"
        ? 0
        : pages.findIndex((item) => {
            return item.title.toLowerCase() === location.pathname.replace("/", "");
          });

    location.pathname === "/" ? (document.title = "Gustavo Cabezas") : (document.title = `Gustavo Cabezas | ${location.pathname.replace("/", "")}`);
    setValue(indexLocation);
    setSelectedIndex(indexLocation);
  }, [location]);

  return (
    <HideOnScroll {...props}>
      <AppBar color="default">
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            <Avatar
              alt="Logo"
              title="Go Home"
              cursor="pointer"
              src={gustavocxLight}
              onClick={() => {
                navigate("/");
              }}
              sx={{
                cursor: "pointer",
              }}
              className="jello-horizontal"
            />
            <Typography
              href="/"
              component="h1"
              variant="h6"
              sx={{
                ml: 2,
                flexGrow: 1,
                textTransform: "uppercase",
              }}
            >
              Gustavocx
            </Typography>

            {/* <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase placeholder="Search…" inputProps={{ "aria-label": "search" }} />
            </Search> */}

            <BottomNavigation
              showLabels
              value={value}
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },
              }}
            >
              {pages.map((item, index) => (
                <BottomNavigationAction
                  key={item.title}
                  onClick={(event) => {
                    handleNavigate(event, index, item.title);
                  }}
                  label={item.title}
                  className="jello-horizontal"
                />
              ))}
            </BottomNavigation>

            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                ml: 1,
                display: {
                  xs: "none",
                  md: "flex",
                },
              }}
            />

            <Stack direction="row" spacing={1}>
              <div></div>

              <IconButton
                onClick={() => {
                  window.open("https://linkedin.com/in/gustavocx/", "_blank", "noreferrer");
                }}
                className="jello-horizontal"
              >
                <LinkedIn titleAccess="LinkedIn" />
              </IconButton>

              <IconButton
                onClick={() => {
                  window.open("https://t.me/gustavocabezas", "_blank", "noreferrer");
                }}
                className="jello-horizontal"
              >
                <Telegram titleAccess="Telegram" />
              </IconButton>

              <IconButton
                onClick={colorMode.toggleColorMode}
                className="jello-horizontal"
                sx={{
                  display: {
                    xs: "none",
                    md: "flex",
                  },
                }}
              >
                {theme.palette.mode === "dark" ? <LightModeRounded titleAccess="Turn off DarkMode" /> : <DarkModeRounded titleAccess="Turn on DarkMode" />}
              </IconButton>
            </Stack>

            {/* <BottomNavigation
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },
              }}
            >
              <BottomNavigationAction key="ToggleDarkMode" onClick={colorMode.toggleColorMode} icon={<LinkedIn />} className="jello-horizontal" />

              <BottomNavigationAction key="ToggleDarkMode" onClick={colorMode.toggleColorMode} icon={<Telegram />} className="jello-horizontal" />

              <BottomNavigationAction key="ToggleDarkMode" onClick={colorMode.toggleColorMode} icon={theme.palette.mode === "dark" ? <LightModeRounded titleaccess="Turn off DarkMode" /> : <DarkModeRounded titleaccess="Turn on DarkMode" />} className="jello-horizontal" />
            </BottomNavigation> */}

            {/* Mobile */}
            {/* <HeaderMobile /> */}
            <Box
              sx={{
                display: {
                  xs: "flex",
                  md: "none",
                },
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <IconButton onClick={toggleDrawer(drawerAnchor, true)} color="inherit" sx={{ ml: 1 }}>
                {open ? <CloseRounded titleAccess="Close menu" className="rotate-in-center" /> : <MenuRounded titleAccess="Open menu" className="rotate-in-center-re" />}
              </IconButton>

              <SwipeableDrawer anchor={drawerAnchor} open={state[drawerAnchor]} onClose={toggleDrawer(drawerAnchor, false)} onOpen={toggleDrawer(drawerAnchor, true)} transitionDuration={500}>
                <Box display="flex" alignItems="center" sx={{ml:1}}>
                  <Avatar
                    alt="Logo"
                    title="Go Home"
                    cursor="pointer"
                    src={gustavocxLight}
                    onClick={() => {
                      navigate("/");
                    }}
                    sx={{
                      cursor: "pointer",
                      mr:2,
                    }}
                    className="jello-horizontal"
                  />
                  <Typography
                    variant="h6"
                    align="center"
                    sx={{
                      mt: 2,
                      mb: 2,
                      color: "inherit",
                      textTransform: "uppercase",
                    }}
                  >
                    Gustavocx
                  </Typography>
                </Box>

                <Divider />

                <Box role="presentation" onClick={toggleDrawer(drawerAnchor, false)} onKeyDown={toggleDrawer(drawerAnchor, false)} sx={{ minWidth: 250 }}>
                  <List>
                    {pages.map((item, index) => (
                      <ListItem key={item.title} disablePadding>
                        <ListItemButton
                          selected={selectedIndex === index}
                          onClick={(event) => {
                            handleNavigate(event, index, item.title);
                          }}
                        >
                          <ListItemIcon>{item.icon}</ListItemIcon>
                          <ListItemText primary={item.title} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>

                <Divider />

                <List>
                  <Typography
                    component="p"
                    variant="h6"
                    align="left"
                    sx={{
                      ml: 2,
                      color: "inherit",
                    }}
                  >
                    Settings
                  </Typography>

                  {/* Setting Dark Mode */}
                  <ListItem key="tgmoasd" disablePadding>
                    <ListItemButton onClick={colorMode.toggleColorMode} color="inherit">
                      <ListItemIcon>{theme.palette.mode === "dark" ? <LightModeRounded titleAccess="Turn off DarkMode" /> : <DarkModeRounded titleAccess="Turn on DarkMode" />}</ListItemIcon>
                      <ListItemText primary={theme.palette.mode === "dark" ? "Dark Mode" : "Light Mode"} />
                    </ListItemButton>
                  </ListItem>

                  {/* Settings Menu  */}
                  <ListItemButton
                    onClick={() => {
                      openSettingMenu ? setOpenSettingMenu(false) : setOpenSettingMenu(true);
                    }}
                  >
                    <ListItemIcon>
                      <SettingsRounded />
                    </ListItemIcon>
                    <ListItemText primary="Menu Position" />
                    {openSettingMenu ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}
                  </ListItemButton>

                  <Collapse in={openSettingMenu} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        selected={selectedIndexListMenu === 0}
                        onClick={() => {
                          setDrawerAnchor("top");
                          setSelectedIndexListMenu(0);
                        }}
                        sx={{
                          pl: 4,
                        }}
                      >
                        <ListItemIcon>
                          <ArrowUpwardRounded />
                        </ListItemIcon>
                        <ListItemText primary="Up" />
                      </ListItemButton>

                      <ListItemButton
                        selected={selectedIndexListMenu === 1}
                        onClick={() => {
                          setDrawerAnchor("right");
                          setSelectedIndexListMenu(1);
                        }}
                        sx={{
                          pl: 4,
                        }}
                      >
                        <ListItemIcon>
                          <ArrowForwardRounded />
                        </ListItemIcon>
                        <ListItemText primary="Right" />
                      </ListItemButton>

                      <ListItemButton
                        selected={selectedIndexListMenu === 2}
                        onClick={() => {
                          setDrawerAnchor("bottom");
                          setSelectedIndexListMenu(2);
                        }}
                        sx={{
                          pl: 4,
                        }}
                      >
                        <ListItemIcon>
                          <ArrowDownwardRounded />
                        </ListItemIcon>
                        <ListItemText primary="Down" />
                      </ListItemButton>

                      <ListItemButton
                        sx={{
                          pl: 4,
                        }}
                        selected={selectedIndexListMenu === 3}
                        onClick={() => {
                          setDrawerAnchor("left");
                          setSelectedIndexListMenu(3);
                        }}
                      >
                        <ListItemIcon>
                          <ArrowBackRounded />
                        </ListItemIcon>
                        <ListItemText primary="Left" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </List>
              </SwipeableDrawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </HideOnScroll>
  );
}
